import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";

const DateRangePicker = (props: any) => {
  const { handleChange, date, DisableFutureDate } = props;

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    handleChange({
      startDate: start ? start.toISOString().split("T")[0] : "",
      endDate: end ? end.toISOString().split("T")[0] : "",
    });
  };

  const filterPastDates = (date: Date) => {
    // Disable dates in the future
    return date <= new Date();
  };

  return (
    <div
      className="date-picker-wrapper"
      style={{ position: "relative", display: "inline-block" }}
    >
      <DatePicker
        selectsRange
        startDate={date.startDate ? new Date(date.startDate) : null}
        endDate={date.endDate ? new Date(date.endDate) : null}
        onChange={handleDateChange}
        isClearable
        showYearDropdown
        dateFormat="dd/MM/yyyy"
        placeholderText="Select Date Range"
        filterDate={DisableFutureDate ? undefined : filterPastDates}
      />
      <FaCalendarAlt
        style={{
          position: "absolute",
          left: 135,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#555",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

export default DateRangePicker;
